import BasicMobileDrawer from '@components/common/molecules/drawer/BasicMobileDrawer';
import { useRootStore } from '@hooks/useRootStore';
import { Box } from "@mui/material";
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import OrderCart from '../common/OrderCart';

interface OrderCartDrawerProps {
}

const OrderCartDrawer: FC<OrderCartDrawerProps> = observer(({ }) => {
    const { orderEditViewStore, userAddressEditViewStore } = useRootStore();
    const { isOrderCartDrawerOpen, setIsOrderCartDrawerOpen } = orderEditViewStore;

    const handleOnClose = () => {
        setIsOrderCartDrawerOpen(false);
    }

    return (
        <BasicMobileDrawer 
        isOpen={isOrderCartDrawerOpen} 
        onClose={handleOnClose}
        height={"92%"}>
            <Box
                sx={{
                    height: '100%',
                    overflow: 'auto',
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                <OrderCart orderEditViewStore={orderEditViewStore} userAddressEditViewStore={userAddressEditViewStore} />
            </Box>
        </BasicMobileDrawer>
    )
})

export default OrderCartDrawer;